// import heroSlide1 from '../../../assets/images/slider_img_1.webp';
// import heroSlide2 from '../../../assets/images/slider_img_2.webp';
// import heroSlide2 from '../../../assets/images/football_slider_img1.webp';
// import heroSlide2 from '../../../assets/images/football_slider_img2.webp';
// import heroSlide3 from '../../../assets/images/slider_img_3.webp';
// import heroSlide3 from '../../../assets/images/slider_img_3.webp';
// import heroSlide4 from '../../../assets/images/football_slider_img4.webp';
// import heroSlide4 from '../../../assets/images/football_slider_img2.webp';
// import heroSlide5 from '../../../assets/images/football_slider_img4.webp';
// import heroSlide5 from '../../../assets/images/slider_img_5.webp';
 // import basketball_banner_1 from '../../../assets/images/basketball_banner_1.png';
// import basketball_banner_2 from '../../../assets/images/basketball_banner_2.png';
// import basketball_banner_3 from '../../../assets/images/basketball_banner_7.jpg';
// import basketball_banner_4 from '../../../assets/images/basketball_banner_4.png';
// import basketball_banner_5 from '../../../assets/images/basketball_banner_5.jpg';
// import basketball_banner_6 from '../../../assets/images/basketball_banner_6.png';
// import football_banner_1 from '../../../assets/images/football_banner_1.jpg';
// import football_banner_2 from '../../../assets/images/football_banner_2.jpg';
// import football_banner_3 from '../../../assets/images/football_banner_3.webp';
// import football_banner_4 from '../../../assets/images/football_banner_4.webp';
// import football_banner_5 from '../../../assets/images/football_banner_5.webp';
// import basketball_court1 from '../../../assets/images/basketball_court1.webp';
// import basketball_court2 from '../../../assets/images/basketball_court2.webp';
// import bb_1 from '../../../assets/images/bb-1.webp';
// import bb_2 from '../../../assets/images/bb-2.webp';
// import bb_3 from '../../../assets/images/bb-3.webp';
// import bb_4 from '../../../assets/images/bb-4.webp';
// import bb_5 from '../../../assets/images/bb-5.webp';

// import fb_1 from '../../../assets/images/georgia1.jpeg';
// import fb_2 from '../../../assets/images/georgia2.jpeg';
// import fb_3 from '../../../assets/images/georgia3.jpeg';
// import fb_4 from '../../../assets/images/georgia4.jpeg';
// import fb_5 from '../../../assets/images/georgia5.webp';
// import fb_6 from '../../../assets/images/georgia6.webp';
// import fb_7 from '../../../assets/images/georgia7.webp';

import fb_1 from '../../../assets/images/atlanta4.png';
import fb_2 from '../../../assets/images/atlanta1.png';
import fb_3 from '../../../assets/images/atlanta2.png';
import fb_4 from '../../../assets/images/atlanta10.png';
import fb_5 from '../../../assets/images/atlanta3.png';

const slides = [
    {
        id: 1,
        image: fb_1,
    },
    {
        id: 2,
        image: fb_2,
    },
    {
        id: 3,
        image: fb_3,
    },
    {
        id: 4,
        image: fb_4,
    },
    {
        id: 5,
        image: fb_5,
    },
]

export default slides